import NajActionButton from './naj-action-button/naj-action-button';
import NajAddress from './naj-address';
import NajBox from './naj-box';
import NajButton from './naj-button/naj-button';
import NajConfirmation from './naj-confirmation';
import NajConfirmationWithSubmessage from './naj-confirmation-with-submessage';
import NajDataTable from './naj-data-table';
import NajDateRange from './naj-date-range';
import NajDynamicField from './naj-dynamic-field';
import NajDynamicForm from './naj-dynamic-form';
import NajErrorText from './naj-error-text';
import NajIcon from './naj-icon/index';
import NajInput from './naj-input';
import NajLoader from './naj-loader';
import NajModal from './naj-modal';
import NajModal2 from './naj-modal-2';
import NajSocialIdentityInput from './naj-social-identity-input';
import NajStepper from './naj-stepper';
import PageContent from './page-content';
import PageHead from './page-head';
import NajItemTable from './naj-item-table';
import NajNoData from './naj-no-data.vue';
import NajSearchBox from './naj-search-box';
import HorizontalNajBox from './horizontal-naj-box';
import NajConfirmationIcon from './naj-confirmation-icon';
import NajAlert from './naj-alert';
import NajAlertModal from './naj-alert-modal';
import NajItemDescription from './naj-item-description';
import NajOtpInput from './OTP/naj-otp-input';
import NajNafathOtpInput from './nafath-Otp/naj-nafath-otp-input.vue';

export default {
  NajActionButton,
  NajAddress,
  NajBox,
  NajButton,
  NajConfirmationWithSubmessage,
  NajConfirmation,
  NajDataTable,
  NajDynamicForm,
  NajErrorText,
  NajIcon,
  NajInput,
  NajLoader,
  NajModal,
  NajModal2,
  NajStepper,
  NajDateRange,
  NajSocialIdentityInput,
  NajDynamicField,
  PageHead,
  PageContent,
  NajItemTable,
  NajNoData,
  HorizontalNajBox,
  NajConfirmationIcon,
  NajSearchBox,
  NajAlert,
  NajAlertModal,
  NajItemDescription,
  NajOtpInput,
  NajNafathOtpInput,
};
